import React, { useEffect, useState } from "react";
import statsBg from "../assets/images/stats-bg.png";

export default function Counter() {
  const stats = [
    { number: 500, label: "sponsor signups", suffix: "+" },
    { number: 600, label: "home visits", suffix: "+" },
    { number: 300, label: "virtual consults", suffix: "+" },
    { number: 300, label: "virtual consults", suffix: "+" },
    { number: 24, label: "support access", suffix: "/7" },
  ];

  const [counts, setCounts] = useState(stats.map(() => 0));

  useEffect(() => {
    const duration = 2000;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);

      setCounts(stats.map((stat) => Math.floor(progress * stat.number)));

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, []);

  const progressDone = (current, target) => current >= target;

  return (
    <div
      className="counter_container"
      style={{ backgroundImage: `url(${statsBg})` }}
    >
      <div className="counter_overlay"></div>

      <div className="counter_content">
        {stats.map((item, index) => (
          <div className="counter_item" key={index}>
            <span className="counter_number">
              {counts[index]}
              {progressDone(counts[index], item.number) ? item.suffix : ""}
            </span>
            <span className="counter_label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
